import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(() => ({
  helpButton: {
    fontSize: 20,
    lineHeight: '23.44px',
    fontWeight: 300,
  },
  selectedButton:{
    fontSize: 20,
    lineHeight: '23.44px',
    fontWeight:500,
  }
}));
